const contentful = require("contentful");

const client = contentful.createClient({
  space: "z71qatn3dasw",
  accessToken: "IuSIYLCaJ8YLAMNCjQZ1whvOzA-7JnIhtNxpD4sk9QY",
});

export default client;